import React, { useState } from 'react'

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Input } from '@mui/material'

type ProlongTrialModalProps = {
  open: boolean
  onClose: (...args: any[]) => any
  onConfirm: (...args: any[]) => any
  disabled?: boolean
}

const ProlongTrialModal = ({ onClose, open, onConfirm, disabled }: ProlongTrialModalProps) => {
  const [extraTrialDays, setExtraTrialDays] = useState(7)

  const handleAddExtraTrialDays = (event: any) => setExtraTrialDays(event.target.value)

  return (
    <Dialog onClose={onClose} open={open}>
      <DialogTitle>Add more days</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} style={{ width: 550 }}>
          <Grid
            size={{
              sm: 6,
            }}>
            Add more trial days:
          </Grid>
          <Grid
            size={{
              sm: 6,
            }}>
            <Input onChange={handleAddExtraTrialDays} type="number" value={extraTrialDays} />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button disabled={disabled} onClick={() => onConfirm(extraTrialDays)}>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ProlongTrialModal
